import { render, staticRenderFns } from "./AddTournament.vue?vue&type=template&id=2f4b3982&scoped=true"
import script from "./AddTournament.vue?vue&type=script&lang=js"
export * from "./AddTournament.vue?vue&type=script&lang=js"
import style0 from "./AddTournament.vue?vue&type=style&index=0&id=2f4b3982&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4b3982",
  null
  
)

export default component.exports